import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import { phantomLedgerWalletName } from '@dynamic-labs/multi-wallet';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import { Typography } from '../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import { logger } from '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../context/ViewContext/ViewContext.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { requiresTwoStepAuthentication } from '../../utils/functions/requiresTwoStepAuthentication/requiresTwoStepAuthentication.js';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import { useConnectAndSignSplitSteps } from '../../utils/hooks/authenticationHooks/useConnectAndSignSplitSteps/useConnectAndSignSplitSteps.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { Button } from '../../components/Button/Button.js';
import '../../components/IconButton/IconButton.js';
import { PoweredByDynamic } from '../../components/PoweredByDynamic/PoweredByDynamic.js';
import { IconWithSpinner, iconRatio } from '../../components/IconWithSpinner/IconWithSpinner.js';
import { TosAndPp } from '../../components/TosAndPp/TosAndPp.js';

const PendingSignatureView = () => {
    const [loading, setLoading] = useState(false);
    const { user, selectedWalletConnector: walletConnector, privacyPolicyUrl, termsOfServiceUrl, } = useInternalDynamicContext();
    const { signAlreadyConnectedUser } = useConnectAndSignSplitSteps();
    const iconSize = 100;
    /**
     * The following check on Phantom+Ledger will be fixed in a future ticket.
     */
    const isPhantomLedger = (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.name) === phantomLedgerWalletName;
    if (!walletConnector) {
        return null;
    }
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield signAlreadyConnectedUser({ walletConnector });
        }
        catch (e) {
            logger.error(e);
        }
        finally {
            setLoading(false);
        }
    });
    const icon = (jsx(WalletIcon, { walletName: walletConnector.name, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    const typographyBodyCopy = isPhantomLedger
        ? "We need your signature to confirm you own this wallet (this doesn't cost gas). Click sign in your wallet to log in."
        : 'We need your signature to confirm you own this wallet. Click sign in your wallet to log in.';
    return (jsxs("div", Object.assign({ className: 'pending-signature__container', "data-testid": 'pending-signature-view' }, { children: [jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true, indicator: 'connected' }), jsx(Typography, Object.assign({ weight: 'medium', variant: 'title', className: classNames('pending-signature__title') }, { children: "Requesting signature" })), jsx(Typography, Object.assign({ variant: 'body_normal', weight: 'regular', className: classNames('pending-signature__copy') }, { children: typographyBodyCopy })), isPhantomLedger && (jsxs(Typography, Object.assign({ variant: 'body_small', weight: 'regular', className: classNames('pending-signature__copy', 'pending-signature__copy--mini') }, { children: [jsx("strong", { children: "Note:" }), " Ledger with Phantom doesn\u2019t support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more."] }))), !user && (jsx(TosAndPp, { mode: 'signing', privacyPolicyUrl: privacyPolicyUrl, termsOfServiceUrl: termsOfServiceUrl })), requiresTwoStepAuthentication(walletConnector) && (jsx(Button, Object.assign({ buttonClassName: 'pending-signature__button', onClick: handleClick, loading: loading, buttonRounded: 'medium', buttonVariant: 'primary', buttonPadding: 'large', expanded: true, typographyProps: {
                    variant: 'button_primary',
                    weight: 'medium',
                } }, { children: "Click to Sign" }))), jsx(PoweredByDynamic, { classNameRoot: 'pending-signature__powered-by' })] })));
};

export { PendingSignatureView };
